/**
 * Próximo dia útil para os vencimentos e a data da tarifa do intermediador (`considerarProximoDiaUtil`): pula fim
 * de semana e os feriados nacionais — fixos e os móveis pela Páscoa. Estaduais e municipais não entram (sem
 * cadastro). Espelho de `DiaUtilHelper` (OrquestradorVendas): a tela só antecipa, o lançamento calcula lá.
 */

/** Feriados nacionais fixos: [mês (1-12), dia]. */
const FERIADOS_FIXOS: [number, number][] = [
    [1, 1],   // Confraternização Universal
    [4, 21],  // Tiradentes
    [5, 1],   // Dia do Trabalho
    [9, 7],   // Independência
    [10, 12], // Nossa Senhora Aparecida
    [11, 2],  // Finados
    [11, 15], // Proclamação da República
    [11, 20], // Consciência Negra
    [12, 25], // Natal
];

function soData(data: Date): Date {
    return new Date(data.getFullYear(), data.getMonth(), data.getDate());
}

function mesmoDia(a: Date, b: Date): boolean {
    return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

export function proximoDiaUtil(data: Date): Date {
    let dia = soData(data);

    while (!ehDiaUtil(dia)) dia = new Date(dia.getFullYear(), dia.getMonth(), dia.getDate() + 1);

    return dia;
}

export function ehDiaUtil(data: Date): boolean {
    return data.getDay() !== 0 && data.getDay() !== 6 && !ehFeriadoNacional(data);
}

export function ehFeriadoNacional(data: Date): boolean {
    const dia = soData(data);

    if (FERIADOS_FIXOS.some(([mes, d]) => dia.getMonth() + 1 === mes && dia.getDate() === d)) return true;

    const p = pascoa(dia.getFullYear());
    const deslocada = (dias: number) => new Date(p.getFullYear(), p.getMonth(), p.getDate() + dias);

    return mesmoDia(dia, deslocada(-48))   // Carnaval (segunda)
        || mesmoDia(dia, deslocada(-47))   // Carnaval (terça)
        || mesmoDia(dia, deslocada(-2))    // Sexta-feira Santa
        || mesmoDia(dia, deslocada(60));   // Corpus Christi
}

/** Domingo de Páscoa pelo algoritmo de Meeus/Jones/Butcher (calendário gregoriano). */
export function pascoa(ano: number): Date {
    const a = ano % 19;
    const b = Math.floor(ano / 100);
    const c = ano % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const mes = Math.floor((h + l - 7 * m + 114) / 31);
    const dia = ((h + l - 7 * m + 114) % 31) + 1;

    return new Date(ano, mes - 1, dia);
}
